import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BreadCrumbModel, BreadCrumbService  } from 'lib/ng2-sapmp/src/ui-components';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot';
import { BREADCRUMBS, MOBILEPIVOTS } from 'config';
import { Router } from '@angular/router';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';

@Component({
  selector: 'app-apple-certificate',
  templateUrl: './apple-certificate.component.html',
  styleUrls: ['./apple-certificate.component.scss']
})
export class AppleCertificateComponent implements OnInit {
  pivots: Array<MobilePivotModel>;

  constructor(private breadCrumbService: BreadCrumbService, private router: Router, private utilityService: UtilityService) { }

  ngOnInit() {
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Apple certificate', routerLink: '/appleCertificate' });
    this.pivots  = MOBILEPIVOTS.APPLECERTIFICATE;
  }

}
